import { useMemo } from 'react';
import useSWR from 'swr';
import { ResponseObject } from '../interfaces';
import request from '../utils/request';

export interface WatcherNetworkInfo {
  symbol: string;
  apr: string;
  totalDelegated: string;
  totalReward: string;
}
/**
 * useWatcherNetworks
 */
export default function useWatcherNetworks() {
  return useSWR(
    '/api/v1/watcher/chain/list',
    url => request.post<ResponseObject<WatcherNetworkInfo[]>>(url),
    {
      refreshInterval: 12_000,
      keepPreviousData: true,
    }
  );
}

export function useWatcherNetwork(symbol?: string) {
  const { data } = useWatcherNetworks();
  return useMemo(
    () => data?.data.data?.find(val => val.symbol === symbol),
    [data, symbol]
  );
}
export function useWatcherNetworkAPR(symbol?: string) {
  const watcherNetworkInfo = useWatcherNetwork(symbol);
  return watcherNetworkInfo?.apr;
}
